import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectRouteParams } from '@frontend/util-ngrx';
import { CATEGORY_FEATURE_KEY, CategoryState } from './categories.reducer';
import { Params } from '@angular/router';

export const selectCategoryState = createFeatureSelector<CategoryState>(CATEGORY_FEATURE_KEY);

export const selectCategoryLoaded = createSelector(selectCategoryState, (state: CategoryState) => state.loaded);

export const selectCategoryError = createSelector(selectCategoryState, (state: CategoryState) => state.error);

export const selectCategoryCategories = createSelector(selectCategoryState, (state: CategoryState) => state.categories);

export const selectCategoryId = createSelector(selectRouteParams, (routerParams: Params) => {
  return routerParams?.['categoryId'] != null ? +routerParams['categoryId'] : undefined;
});
